export default __webpack_public_path__ + "static/media/round-boxim1.b8702ace.png";